export let hrms15eColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '100',
      style: 'min-width: 200px;'
    }, {
      key: 'qtyapp',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '190',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'AppraisalScore',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '130',
      style: 'min-width: 500px;',
      class: 'align-center',
      headerRow: 1,
      colspan: 4,
      rowspan: 1
    }, {
      key: 'avgbeh',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '140',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'avgcmp',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '150',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'avgkpi',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '160',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'qtytot',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '170',
      class: 'align-right',
      style: 'min-width: 100px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRAP31EC1',
      labelIndex: '180',
      style: 'min-width: 200px;'
    }
  ]
  let detail1Desc1TableColumns = [
    {
      key: 'codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 200px;',
      inlineType: 'lov',
      lovType: 'codcours',
      eventName: 'codcours',
      validateRules: 'max:6'
    }, {
      key: 'desc_codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '110',
      style: 'min-width: 200px;',
      validateRules: 'max:500'
    }, {
      key: 'desc_codcate',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '120',
      style: 'min-width: 200px;',
      validateRules: 'max:100'
    }, {
      key: 'desc_typtrain',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '130',
      style: 'min-width: 200px;',
      validateRules: 'max:100'
    }, {
      key: 'qtyppc',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '140',
      class: 'align-center',
      style: 'min-width: 150px;',
      validateRules: 'max:4'
    }
  ]
  let courseGapPopupTableColumns = [
    {
      key: 'codskill',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '170',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codskill',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '180',
      style: 'min-width: 200px;'
    }, {
      key: 'grade',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '190',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '200',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '210',
      style: 'min-width: 200px;'
    }
  ]
  let detail2Desc1TableColumns = [
    {
      key: 'codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 200px;',
      inlineType: 'lov',
      lovType: 'codcours',
      eventName: 'codcours',
      validateRules: 'max:6'
    }, {
      key: 'desc_codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcate',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_typtrain',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'qtyppc',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '140',
      class: 'align-center',
      style: 'min-width: 150px;'
    }
  ]
  let detail3Desc2TableColumns = [
    {
      key: 'kpino',
      name: '',
      labelCodapp: 'HRAP31EC7',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'kpiitem',
      name: '',
      labelCodapp: 'HRAP31EC7',
      labelIndex: '50',
      style: 'min-width: 200px;'
    }, {
      key: 'kpiwgt',
      name: '',
      labelCodapp: 'HRAP31EC7',
      labelIndex: '60',
      class: 'align-right',
      style: 'min-width: 200px;'
    }, {
      key: 'qtyscor',
      name: '',
      labelCodapp: 'HRAP31EC7',
      labelIndex: '70',
      class: 'align-right',
      style: 'min-width: 200px;'
    }, {
      key: 'avgscor',
      name: '',
      labelCodapp: 'HRAP31EC7',
      labelIndex: '80',
      class: 'align-right',
      style: 'min-width: 200px;'
    }
  ]
  let detail3Desc3TableColumns = [
    {
      key: 'workno',
      name: '',
      labelCodapp: 'HRAP31EC10',
      labelIndex: '150',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'workitem',
      name: '',
      labelCodapp: 'HRAP31EC10',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'workfin',
      name: '',
      labelCodapp: 'HRAP31EC10',
      labelIndex: '170',
      style: 'min-width: 200px;'
    }
  ]
  let detail3InfoTableColumns = [
    {
      key: 'workno',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '180',
      class: 'align-center',
      style: 'min-width: 80px;',
      inlineType: 'text',
      eventName: 'workno',
      validateRules: 'required|max:2'
    }, {
      key: 'workitem',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '190',
      style: 'min-width: 200px;',
      inlineType: 'text',
      eventName: 'workitem',
      validateRules: 'required|max:600'
    }, {
      key: 'actbedon',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '200',
      style: 'min-width: 200px;',
      inlineType: 'text',
      eventName: 'actbedon',
      validateRules: 'max:600'
    }
  ]
  let detail3InfoDesc1TableColumns = [
    {
      key: 'codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 200px;',
      inlineType: 'lov',
      lovType: 'codcours',
      eventName: 'codcours',
      validateRules: 'max:6'
    }, {
      key: 'desc_codcours',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codcate',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_typtrain',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '130',
      style: 'min-width: 200px;'
    }, {
      key: 'qtyppc',
      name: '',
      labelCodapp: 'HRAP31EC32',
      labelIndex: '140',
      class: 'align-center',
      style: 'min-width: 150px;'
    }
  ]
  let detail3InfoDesc2PopupTableColumns = [
    {
      key: 'dteapkpi',
      name: '',
      labelCodapp: 'HRAP31EC9',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;',
      dataType: 'date'
    }, {
      key: 'actbedon',
      name: '',
      labelCodapp: 'HRAP31EC9',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'mtrvalue',
      name: '',
      labelCodapp: 'HRAP31EC9',
      labelIndex: '120',
      class: 'align-right',
      style: 'min-width: 100px;'
    }, {
      key: 'mtrvalnet',
      name: '',
      labelCodapp: 'HRAP31EC9',
      labelIndex: '130',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detail1Desc1Table: detail1Desc1TableColumns,
      courseGapPopupTable: courseGapPopupTableColumns,
      detail2Desc1Table: detail2Desc1TableColumns,
      detail3Desc2Table: detail3Desc2TableColumns,
      detail3Desc3Table: detail3Desc3TableColumns,
      detail3InfoTable: detail3InfoTableColumns,
      detail3InfoDesc1Table: detail3InfoDesc1TableColumns,
      detail3InfoDesc2PopupTable: detail3InfoDesc2PopupTableColumns
    },
    th: {
      index: indexColumns,
      detail1Desc1Table: detail1Desc1TableColumns,
      courseGapPopupTable: courseGapPopupTableColumns,
      detail2Desc1Table: detail2Desc1TableColumns,
      detail3Desc2Table: detail3Desc2TableColumns,
      detail3Desc3Table: detail3Desc3TableColumns,
      detail3InfoTable: detail3InfoTableColumns,
      detail3InfoDesc1Table: detail3InfoDesc1TableColumns,
      detail3InfoDesc2PopupTable: detail3InfoDesc2PopupTableColumns
    }
  }
}

export let hrms15eMaxRowspan = {
  index: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrms15e.js